var _defs, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextSpotify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 15,
    viewBox: "0 0 154 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        font-size: 28px;\r\n        fill: #fff;\r\n        text-anchor: middle;\r\n        font-family: Inter;\r\n        font-weight: 700;\r\n      }\r\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Pre-Save_on_Spotify",
    "data-name": "Pre-Save on Spotify",
    className: "cls-1",
    transform: "translate(76.805 11.557) scale(0.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "Pre-Save on Spotify"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSpotify);
export default __webpack_public_path__ + "static/media/text_spotify.553a4c9585e2754c865161631a4d690e.svg";
export { ForwardRef as ReactComponent };